import { useTableColumnsContext } from './TableColumns';
import TableCell from './TableCell';
import React from 'react';

interface TableFooterProps {
    height: number;
    style?: React.CSSProperties;
}

const TableFooter: React.FC<TableFooterProps> = ({
    height,
    style,
}) => {
    const { data } = useTableColumnsContext();

    return (
        <div
            className="TableRow TableRow__footer"
            style={{ height, ...style }}
            data-testid="tableFooter"
        >
            {data.map((col, index) => (
                <TableCell
                    key={col.key ?? `footer-col-${index}`}
                    isFooter
                    accentLevel={col.accentLevel}
                    lockAccent={col.lockAccent}
                    style={{
                        ...col.style?.cell,
                        ...col.style?.footer,
                    }}
                    testId={`tableFooterColumn${index}`}
                >
                    {col.footer}
                </TableCell>
            ))}
        </div>
    );
};

export default TableFooter;
